import type { HelpFile } from '../../types/help'
import { RequestInspectorDetailTestIds } from '../../../testids/RequestInspectorDetailTestIds'

export const requestInspectorDetailHelp: HelpFile = {
  docPage: '/docs/observability/request-inspector',
  texts: {
    [RequestInspectorDetailTestIds.requestInspectorDetailPage]:
      'Drill-down into a captured request — child spans, SQL activity, and timing breakdown.',
    [RequestInspectorDetailTestIds.btnDownloadTrace]:
      'Download the full trace as JSON for offline analysis or sharing with support.',
    [RequestInspectorDetailTestIds.cardTitleDetail]:
      'Core attributes of the captured request — URL, method, status code, and duration.',
    [RequestInspectorDetailTestIds.cardTitleRequests]:
      'Child requests and downstream calls made while serving this request.',
    [RequestInspectorDetailTestIds.colDuration]:
      'Wall-clock time the request or span took.',
    [RequestInspectorDetailTestIds.colMethod]: null,
    [RequestInspectorDetailTestIds.colSqlCount]:
      'Number of SQL statements executed during this span.',
    [RequestInspectorDetailTestIds.colSqlTime]:
      'Cumulative time spent on SQL during this span.',
    [RequestInspectorDetailTestIds.colStatus]: null,
    [RequestInspectorDetailTestIds.colUrl]: null,
    [RequestInspectorDetailTestIds.requestsTable]:
      'All captured requests that participated in this trace.',
  },
}
